import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';

import { CmpsCommentComponent } from './comment.component';

@NgModule({
    declarations: [CmpsCommentComponent],
    exports: [CmpsCommentComponent],
    imports: [CommonModule, EditorModule, FormsModule],
})
export class CmpsCommentModule {}
